<form [formGroup]="config">
  <ul class="section-config">
    <li class="config-row">
      <section class="basic-flex-container">
        <div class="template-entity-type-wrapper config-field-container">
          <mat-checkbox formControlName="required"> Required </mat-checkbox>
        </div>
        <div class="template-entity-type-wrapper config-field-container">
          <mat-checkbox
            formControlName="autoSelectFiles"
            [matTooltip]="'Check to automatically select all available certification files when this section loads'"
            [matTooltipPosition]="'right'"
            [matTooltipShowDelay]="500"
          >
            Auto-select files
          </mat-checkbox>
        </div>
        @if (!combinedOutput) {
          <div class="template-entity-type-wrapper config-field-container">
            <mat-checkbox
              formControlName="saveBackToDataSource"
              [matTooltip]="'Check to save this section back to the data source when the envelope is completed'"
              [matTooltipPosition]="'right'"
              [matTooltipShowDelay]="500"
            >
              Save back to data source
            </mat-checkbox>
          </div>
        }
      </section>
    </li>
    <li class="config-row">
      <section class="basic-flex-container">
        <div class="config-field-container">
          <label>Certification restrictions</label>
          <mat-select formControlName="certificationRestrictionsMode">
            @for (option of restrictionModeOptions; track option.value) {
              <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
          @if (certificationsLoaded) {
            <app-multi-select-autocomplete
              [queryFunction]="certificationQueryFn"
              [initialSelectedValues]="initialCertificationValues"
              (selectionChange)="onCertificationRestrictionsChange($event)"
            >
            </app-multi-select-autocomplete>
          } @else {
            <p>Loading certifications...</p>
          }
        </div>
        <div class="config-field-container">
          <label>Certification group restrictions</label>
          <mat-select formControlName="certificationGroupRestrictionsMode">
            @for (option of restrictionModeOptions; track option.value) {
              <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
          @if (certificationsLoaded) {
            <app-multi-select-autocomplete
              [queryFunction]="certificationGroupQueryFn"
              [initialSelectedValues]="initialCertificationGroupValues"
              (selectionChange)="onCertificationGroupRestrictionsChange($event)"
            >
            </app-multi-select-autocomplete>
          } @else {
            <p>Loading certification groups...</p>
          }
        </div>
      </section>
    </li>
    <li class="config-row">
      <section class="basic-flex-container">
        <div class="config-field-container">
          <label
            matTooltip="Restrict based on CandidateCertification's displayStatus"
            matTooltipPosition="above"
            matTooltipShowDelay="500"
          >Display status restriction</label>
          <app-display-status-restriction [control]="displayStatusControl"></app-display-status-restriction>
        </div>
        <div class="config-field-container">
          <label
            matTooltip="Restrict selectable certification files to those linked to a requirement for this template's entity type"
            matTooltipPosition="above"
            matTooltipShowDelay="500"
          >Requirement restriction</label>
          <mat-select formControlName="requirementRestriction">
            @for (option of requirementRestrictionOptions; track option.value) {
              <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
        </div>
      </section>
    </li>
  </ul>
</form>
